<template>
  <validation-observer
    ref="create-admin-form"
    tag="form"
    class="modal-card"
    @submit.prevent.stop="createUpdateAdmin"
  >
    <header class="modal-card-head">
      <p class="modal-card-title">
        <span v-if="id === null">
          Create new administrator
        </span>
        <span v-else>
          Update administrator
        </span>
      </p>
      <button
        class="delete"
        aria-label="close"
        type="button"
        @click.prevent.stop="$emit('close');"
      />
    </header>
    <section class="modal-card-body">
      <div class="section">
        <div class="field">
          <label
            for="firstname"
            class="label"
          >
            First name:
          </label>
          <div class="control">
            <textbox-with-validation
              id="firstname"
              v-model="admin.firstName"
              name="firstname"
              rules="required"
              placeholder="First name"
            />
          </div>
        </div>
        <div class="field">
          <label
            for="lastname"
            class="label"
          >
            Last name:
          </label>
          <div class="control">
            <textbox-with-validation
              id="lastname"
              v-model="admin.lastName"
              name="lastname"
              rules="required"
              placeholder="Last name"
            />
          </div>
        </div>
        <div class="field">
          <label
            for="email"
            class="label"
          >
            City Of Philadelphia e-mail
          </label>
          <div class="control">
            <textbox-with-validation
              id="email"
              v-model="admin.email"
              name="email"
              rules="required|email|isPhilaGov"
              type="text"
              placeholder="abcd@phila.gov"
            />
          </div>
        </div>
      </div>
    </section>
    <footer class="modal-card-foot is-justified-end">
      <button
        class="button is-primary"
        type="submit"
      >
        Save changes
      </button>
      <button
        class="button is-dark"
        @click.prevent.stop="$emit('close');"
      >
        Cancel
      </button>
    </footer>
  </validation-observer>
</template>

<script>
import { clone } from 'lodash';
import TextboxWithValidation from "@/components/common/InputTextWithValidation";

export default {
  name: 'AdminForm',
  components: {
    TextboxWithValidation,
  },
  props: {
    id: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      admin: {
        id: undefined,
        firstName: '',
        lastName: '',
        email: '',
      },
    };
  },
  beforeMount() {
    if (this.id) {
      this.admin = clone(this.$store.state.users.admins.find(a => a.id === this.id));
    }
  },
  methods: {
    async createUpdateAdmin() {
      const valid = await this.$refs['create-admin-form'].validate();
      if (!valid) {
        return false;
      }

      if (!this.admin.id) {
        // create
        if (await this.$store.dispatch('users/createAdmin', this.admin)) {
          this.$refs['create-admin-form'].reset();
          this.$emit('close');
        }
      } else {
        // update
        if (await this.$store.dispatch('users/updateAdmin', this.admin)) {
          this.$refs['create-admin-form'].reset();
          this.$emit('close');
        }
      }
    },
  },
};
</script>

<style>

</style>